import React from 'react';
import { connect } from 'react-redux';
import { setOpenAuthDialog } from '../../services/store/features/appSlice';
import { withRouter } from "react-router-dom";
import { withStyles } from '@mui/styles';
import authService from './../../services/auth';

import { HomeIcon, WorldIcon, UserIcon, SearchIcon } from './../commons/Icons';

import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';

class MainFooter extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      nav: null,
    };
  }

  componentDidMount () {
    const { history } = this.props;
    if (!history && !history.location && history.location.pathname) {
      return;
    }
    this.setState({nav: history.location.pathname});
  }

  navChange (nav) {
    this.setState({nav});
    this.redirectTo(nav);
  }

  redirectTo (route) {
    const { history } = this.props;
    if (history) {
      history.push(route);
    }
  }

  logOut () {
    authService.logOut();
    this.redirectTo('/');
  }

  render () {
    const { classes, appStore } = this.props;

    return (
      <Box displayPrint="none">
        <AppBar color="inherit" position="fixed" className={classes.appBottomBar}>

            <BottomNavigation
              classes={{root: classes.bottomNavigationRoot}}
              value={this.state.nav}
              onChange={(event, nav) => {
                this.navChange(nav);
              }}
              className={classes.root}
            >
              { appStore?.auth?.id_user && (
                <BottomNavigationAction
                  classes={{root: classes.bottomNavigationActionRoot, selected: classes.bottomNavigationActionSelected, label: classes.bottomNavigationActionLabel}}
                  value="/"
                  icon={<HomeIcon />}
                  label="Profil"
                  showLabel={true}
                />
              ) }
              { !appStore?.auth?.id_user && (
                <BottomNavigationAction
                  classes={{root: classes.bottomNavigationActionRoot, selected: classes.bottomNavigationActionSelected, label: classes.bottomNavigationActionLabel}}
                  onClick={() => this.props.setOpenAuthDialog && this.props.setOpenAuthDialog(true)}
                  icon={<UserIcon />}
                  label="Connexion"
                  showLabel={true}
                />
              ) }
              <BottomNavigationAction
                classes={{root: classes.bottomNavigationActionRoot, selected: classes.bottomNavigationActionSelected, label: classes.bottomNavigationActionLabel}}
                value="/network"
                icon={<WorldIcon />}
                label="Réseau"
                showLabel={true}
                id="main-footer--btn-network"
              />
              { appStore?.auth?.id_user && false && (
                <BottomNavigationAction
                  classes={{root: classes.bottomNavigationActionRoot, selected: classes.bottomNavigationActionSelected, label: classes.bottomNavigationActionLabel}}
                  value="/search"
                  icon={<SearchIcon />}
                  label="Rechercher"
                  showLabel={true}
                />
              ) }
            </BottomNavigation>
        </AppBar>
      </Box>
    );
  }
}

const styles = theme => ({
  appBottomBar: {
    zIndex: theme.zIndex.drawer + 2,
    top: 'auto',
    bottom: 0,
  },
  bottomTitle: {
    flexBasis: '70%',
    flexShrink: 0,
    flexGrow: 1,
    fontSize: 14,
  },
  userInfos: {
    display: 'flex',
    alignItems: 'center'
  },
  bottomNavigationActionRoot: {
    minWidth: 60,
  },
  bottomNavigationActionSelected: {
  },
  bottomNavigationActionLabel: {
    hyphens: 'none',
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
    '&.Mui-selected': {
      [theme.breakpoints.down('sm')]: {
        fontSize: 10,
      },
    },
  },
});

const mapStateToProps = state => ({
	appStore: state.app,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setOpenAuthDialog: (value) => dispatch(setOpenAuthDialog(value)),
  }
};

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(MainFooter)));
